class AlphabetFilter extends HTMLElement {
  constructor() {
    super();
    
    this.filteredContainer = document.querySelector('.brands_list')
    this.resetFilterLetter = "#"
  }

  connectedCallback() {

    this.querySelectorAll('.letter-btn').forEach(letter => {
      letter.addEventListener('click', (e) => {
        let selectedLetter = e.target.dataset.letter
        if (selectedLetter == this.resetFilterLetter) {
          this.filteredContainer.classList.remove('filtered')
          this.removeBrandListActiveClass()
        } else {
          this.filteredContainer.classList.add('filtered')
          this.removeBrandListActiveClass()
          this.filteredContainer.querySelector(`[data-letter="${selectedLetter}"]`).classList.add('active')
        }
        
        this.scrollToTarget(selectedLetter)
      });
    }); 
  }

  removeBrandListActiveClass() {
    console.log(this.filteredContainer)
    console.log(this.filteredContainer.querySelectorAll('.letter_brand_list.active'))
    this.filteredContainer.querySelectorAll('.letter_brand_list.active').forEach(function(list) {
      list.classList.remove('active')
    })
  }

  scrollToTarget(letter) {
    if (letter != this.resetFilterLetter) {
      this.filteredContainer.querySelector(`[data-letter="${letter}"]`).scrollIntoView({ 
        behavior: "smooth", 
        block: "start", 
        inline: "nearest" 
      });
    }
  }
}
customElements.define('alphabet-filter', AlphabetFilter);